/* global obApi */
import createAdapter from './createAdapter'
export const outbrain = createAdapter(() => !!window.obApi, {
  page() {
    obApi('track', 'Clickouts')
  },
  install() {
    obApi('track', 'installs')
  },
})
